import React from 'react';
import { Redirect } from 'react-router-dom';
import { Route } from 'react-router-dom';
import * as FeatherIcon from 'react-feather';
import * as BootstrapIcon from 'react-icons/bs';

import { isUserAuthenticated, getLoggedInUser } from '../helpers/authUtils';

// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
// dashboard
const Dashboard = React.lazy(() => import('../pages/dashboard'));

// dashboard
const DashboardStock = React.lazy(() => import('../pages/dashboard-stock'));

// Admins
const Admins = React.lazy(() => import('../pages/admins'));
const AdminsAdd = React.lazy(() => import('../pages/admins/add'));
const AdminsList = React.lazy(() => import('../pages/admins/list'));

// Franchises
const Franchises = React.lazy(() => import('../pages/franchises'));
const FranchisesAdd = React.lazy(() => import('../pages/franchises/add'));
const FranchisesList = React.lazy(() => import('../pages/franchises/list'));

// Orders
const Orders = React.lazy(() => import('../pages/orders'));
const OrdersAdd = React.lazy(() => import('../pages/orders/add'));
const OrdersList = React.lazy(() => import('../pages/orders/list'));
const OrdersHistories = React.lazy(() => import('../pages/orders/histories'));

// Ads
const AdsList = React.lazy(() => import('../pages/ads/list'));

// Promotions
const Promotions = React.lazy(() => import('../pages/promotions'));
const PromotionsAdd = React.lazy(() => import('../pages/promotions/add'));
const PromotionsList = React.lazy(() => import('../pages/promotions/list'));
const PromotionsHistories = React.lazy(() => import('../pages/promotions/histories'));

// Customers
const Customers = React.lazy(() => import('../pages/customers'));
const CustomersAdd = React.lazy(() => import('../pages/customers/add'));
const CustomersList = React.lazy(() => import('../pages/customers/list'));


const VoucherHistories = React.lazy(() => import('../pages/vouchers/histories'));

// Distances
const Distances = React.lazy(() => import('../pages/distances'));
const DistancesAdd = React.lazy(() => import('../pages/distances/add'));
const DistancesList = React.lazy(() => import('../pages/distances/list'));

// Shippings
const Shippings = React.lazy(() => import('../pages/shippings'));
const ShippingsAdd = React.lazy(() => import('../pages/shippings/add'));
const ShippingsList = React.lazy(() => import('../pages/shippings/list'));

// Riders
const Riders = React.lazy(() => import('../pages/riders'));
const RidersAdd = React.lazy(() => import('../pages/riders/add'));
const RidersList = React.lazy(() => import('../pages/riders/list'));

// Products
const Products = React.lazy(() => import('../pages/products'));
const ProductsAdd = React.lazy(() => import('../pages/products/add'));
const ProductsList = React.lazy(() => import('../pages/products/list'));
const ProductsHistories = React.lazy(() => import('../pages/products/histories'));

// Durians
const Durians = React.lazy(() => import('../pages/durians'));
const DuriansAdd = React.lazy(() => import('../pages/durians/add'));
const DuriansList = React.lazy(() => import('../pages/durians/list'));
const DuriansSuspend = React.lazy(() => import('../pages/durians/suspend'));
const DuriansActivities = React.lazy(() => import('../pages/durians/activities'));

// Durian-Used
const DurianUsed = React.lazy(() => import('../pages/durian-used'));
const DurianUsedManagement = React.lazy(() => import('../pages/durian-used/management'));
const DurianUsedHistories = React.lazy(() => import('../pages/durian-used/histories'));

// Durian Stores
const DurianStores = React.lazy(() => import('../pages/durian-stores'));
const DurianStoresMerchant = React.lazy(() => import('../pages/durian-stores/merchants'));
const DurianStoresAdd = React.lazy(() => import('../pages/durian-stores/add'));
const DurianStoresList = React.lazy(() => import('../pages/durian-stores/list'));
const DurianStoresHistories = React.lazy(() => import('../pages/durian-stores/histories'));
const DurianStoresActivities = React.lazy(() => import('../pages/durian-stores/activities'));

// Stocks
const Stocks = React.lazy(() => import('../pages/stocks'));
const StocksAdd = React.lazy(() => import('../pages/stocks/add'));
const StocksList = React.lazy(() => import('../pages/stocks/list'));
const StocksSuspend = React.lazy(() => import('../pages/stocks/suspend'));
const StocksActivities = React.lazy(() => import('../pages/stocks/activities'));

// Expends
const Expends = React.lazy(() => import('../pages/expends'));
const ExpendsAdd = React.lazy(() => import('../pages/expends/add'));
const ExpendsList = React.lazy(() => import('../pages/expends/list'));

// Expends
const ExpendTypesAdd = React.lazy(() => import('../pages/expends/type'));
const ExpendTypesList = React.lazy(() => import('../pages/expends/type-list'));

// Budget
const Budgets = React.lazy(() => import('../pages/budget'));
const BudgetsAdd = React.lazy(() => import('../pages/budget/add'));
const BudgetsList = React.lazy(() => import('../pages/budget/list'));

// Budget
const BudgetTypesAdd = React.lazy(() => import('../pages/budget/type'));
const BudgetTypesList = React.lazy(() => import('../pages/budget/type-list'));

// Debt
const Debts = React.lazy(() => import('../pages/debt'));
const DebtsAdd = React.lazy(() => import('../pages/debt/add'));
const DebtsList = React.lazy(() => import('../pages/debt/list'));

// Debt
const DebtTypesAdd = React.lazy(() => import('../pages/debt/type'));
const DebtTypesList = React.lazy(() => import('../pages/debt/type-list'));

// Expense
const Expenses = React.lazy(() => import('../pages/expense'));
const ExpensesAdd = React.lazy(() => import('../pages/expense/add'));
const ExpensesList = React.lazy(() => import('../pages/expense/list'));

// Expense
const ExpenseTypesAdd = React.lazy(() => import('../pages/expense/type'));
const ExpenseTypesList = React.lazy(() => import('../pages/expense/type-list'));

// Income
const Incomes = React.lazy(() => import('../pages/income'));
const IncomesAdd = React.lazy(() => import('../pages/income/add'));
const IncomesList = React.lazy(() => import('../pages/income/list'));

// Income
const IncomeTypesAdd = React.lazy(() => import('../pages/income/type'));
const IncomeTypesList = React.lazy(() => import('../pages/income/type-list'));

// My Property
const MyProperties = React.lazy(() => import('../pages/my-property'));
const MyPropertiesAdd = React.lazy(() => import('../pages/my-property/add'));
const MyPropertiesList = React.lazy(() => import('../pages/my-property/list'));

// My Property
const MyPropertiesTypesAdd = React.lazy(() => import('../pages/my-property/type'));
const MyPropertiesTypesList = React.lazy(() => import('../pages/my-property/type-list'));

// Employees
const Employees = React.lazy(() => import('../pages/employees'));
const EmployeesAdd = React.lazy(() => import('../pages/employees/add'));
const EmployeesList = React.lazy(() => import('../pages/employees/list'));

// Settings
const Settings = React.lazy(() => import('../pages/settings'));
// Aboutus
const Aboutus = React.lazy(() => import('../pages/aboutus'));

// handle auth and authorization
const PrivateRoute = ({ component: Component, roles, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (!isUserAuthenticated()) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{ pathname: '/account/login', state: { from: props.location } }} />;
            }

            const loggedInUser = getLoggedInUser();
            // check if route is restricted by role
            if (roles && roles.indexOf(loggedInUser.role) === -1) {
                // role not authorised so redirect to home page
                return <Redirect to={{ pathname: '/' }} />;
            }

            // authorised so return component
            return <Component {...props} />;
        }}
    />
);

// root routes
const rootRoute = {
    path: '/',
    exact: true,
    component: () => {
        if (getLoggedInUser().role === "Rider") {
            return <Redirect to="/distances/list" />
        } else if (getLoggedInUser().role === "Finance") {
            return <Redirect to="/expends/list" />
        } else if (getLoggedInUser().role === "Staff") {
            return <Redirect to="/orders/list" />
        } else if (getLoggedInUser().role === "AdminFranchise") {
            return <Redirect to="/orders/list" />
        } else if (getLoggedInUser().role === "OwnerFranchise") {
            return <Redirect to="/dashboard" />
        } else {
            return <Redirect to="/dashboard" />
        }
    },
    route: PrivateRoute,
};

// dashboards
const dashboardRoutes = {
    path: '/dashboard',
    name: 'รายงาน',
    icon: FeatherIcon.BarChart,
    header: 'Dashboard',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    component: Dashboard,
    roles: ['Admin', 'SuperAdmin', 'RootAdmin', 'OwnerFranchise'],
    route: PrivateRoute,

    // children: [
    //     {
    //         path: '/dashboard/report',
    //         name: 'รายงาน',
    //         icon: BootstrapIcon.BsArrowReturnRight,
    //         badge: {
    //             variant: 'success',
    //             text: '1',
    //         },
    //         component: Dashboard,
    //         roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
    //         route: PrivateRoute,
    //     },
    //     {
    //         path: '/dashboard/stock',
    //         name: 'รายงานสต๊อก',
    //         icon: BootstrapIcon.BsArrowReturnRight,
    //         badge: {
    //             variant: 'success',
    //             text: '10',
    //         },
    //         component: DashboardStock,
    //         roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
    //         route: PrivateRoute,
    //     },
    // ],
};

const dashboardStockRoutes = {
    path: '/dashboard/stock',
    name: 'รายงาน',
    icon: FeatherIcon.BarChart,
    // header: 'Dashboard',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    component: DashboardStock,
    roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
    route: PrivateRoute,

    // children: [
    //     {
    //         path: '/dashboard/report',
    //         name: 'รายงาน',
    //         icon: BootstrapIcon.BsArrowReturnRight,
    //         badge: {
    //             variant: 'success',
    //             text: '1',
    //         },
    //         component: Dashboard,
    //         roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
    //         route: PrivateRoute,
    //     },
    //     {
    //         path: '/dashboard/stock',
    //         name: 'รายงานสต๊อก',
    //         icon: BootstrapIcon.BsArrowReturnRight,
    //         badge: {
    //             variant: 'success',
    //             text: '10',
    //         },
    //         component: DashboardStock,
    //         roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
    //         route: PrivateRoute,
    //     },
    // ],
};

// Admins
const adminsRoutes = {
    path: '/admins',
    name: 'แอดมิน',
    icon: FeatherIcon.Smile,
    header: 'Admins',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/admins/add',
            name: 'เพิ่มแอดมิน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: AdminsAdd,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/admins/list',
            name: 'รายชื่อแอดมิน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: AdminsList,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Franchises
const franchisesRoutes = {
    path: '/franchises',
    name: 'เฟรนไชส์',
    icon: FeatherIcon.Award,
    header: 'Franchises',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/franchises/add',
            name: 'เพิ่มเฟรนไชส์',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: FranchisesAdd,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/franchises/list',
            name: 'รายชื่อเฟรนไชส์',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: FranchisesList,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Orders
const ordersRoutes = {
    path: '/orders',
    name: 'คำสั่งซื้อ',
    icon: FeatherIcon.ShoppingBag,
    header: 'Orders',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    // component: Orders,
    // roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
    // route: PrivateRoute,
    children: [
        {
            path: '/orders/add',
            name: 'เพิ่มคำสั่งซื้อ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: OrdersAdd,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
            route: PrivateRoute,
        },
        {
            path: '/orders/list',
            name: 'รายการคำสั่งซื้อ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: OrdersList,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
            route: PrivateRoute,
        },
        {
            path: '/orders/histories',
            name: 'ประวัติรายการคำสั่งซื้อ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: OrdersHistories,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
            route: PrivateRoute,
        },
    ],
};



// Promotions
const promotionsRoutes = {
    path: '/promotions',
    name: 'โปรโมชั่น',
    icon: FeatherIcon.Tag,
    header: 'Promotions',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/promotions/add',
            name: 'เพิ่มโปรโมชั่น',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: PromotionsAdd,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/promotions/list',
            name: 'รายการโปรโมชั่น',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: PromotionsList,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
            route: PrivateRoute,
        },
        {
            path: '/promotions/histories',
            name: 'ประวัติรายการโปรโมชั่น',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: PromotionsHistories,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
            route: PrivateRoute,
        },
    ],
};

// Customers
const customersRoutes = {
    path: '/customers',
    name: 'ลูกค้า',
    icon: FeatherIcon.User,
    header: 'Customers',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/customers/add',
            name: 'เพิ่มลูกค้า',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: CustomersAdd,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
            route: PrivateRoute,
        },
        {
            path: '/customers/list',
            name: 'รายชื่อลูกค้า',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: CustomersList,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
            route: PrivateRoute,
        },
        
    ],
};

// Vouchers
const voucherRoutes = {
    path: '/vouchers',
    name: 'บัตรกำนัล',
    icon: FeatherIcon.Gift,
    header: 'Vouchers',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/vouchers/histories',
            name: 'ประวัติ Voucher',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: VoucherHistories,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        
    ],
};

// Ads
const adsRoutes = {
    path: '/ads',
    name: 'โฆษณา',
    icon: FeatherIcon.Activity,
    header: 'Ads',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/ads/list',
            name: 'รายการโฆษณา',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: AdsList,
            roles: ['Staff', 'Finance', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
            route: PrivateRoute,
        },
    ],
};

// Distances
const distancesRoutes = {
    path: '/distances',
    name: 'ระยะทาง',
    icon: FeatherIcon.MapPin,
    header: 'Distances',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/distances/add',
            name: 'เพิ่มระยะทาง',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DistancesAdd,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin', 'Rider'],
            route: PrivateRoute,
        },
        {
            path: '/distances/list',
            name: 'รายการระยะทาง',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DistancesList,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin', 'Rider'],
            route: PrivateRoute,
        },
    ],
};


// Shippings
const shippingsRoutes = {
    path: '/shippings',
    name: 'ขนส่ง',
    icon: FeatherIcon.Package,
    header: 'Shippings',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/shippings/add',
            name: 'เพิ่มขนส่ง',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ShippingsAdd,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/shippings/list',
            name: 'รายชื่อขนส่ง',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ShippingsList,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Riders
const ridersRoutes = {
    path: '/riders',
    name: 'ไรเดอร์',
    icon: FeatherIcon.Truck,
    header: 'Riders',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/riders/add',
            name: 'เพิ่มไรเดอร์',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: RidersAdd,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/riders/list',
            name: 'รายชื่อไรเดอร์',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: RidersList,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Products
const productsRoutes = {
    path: '/products',
    name: 'สินค้า',
    icon: FeatherIcon.Coffee,
    header: 'Products',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/products/add',
            name: 'เพิ่มสินค้า',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ProductsAdd,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/products/list',
            name: 'รายการสินค้า',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ProductsList,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/products/histories',
            name: 'ประวัติรายการสินค้า',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ProductsHistories,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// DurianStores
const durianStoresRoutes = {
    path: '/durian-stores',
    name: '1.นำเข้าทุเรียน',
    icon: FeatherIcon.Home,
    header: 'Durian Stores',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/durian-stores/add',
            name: 'นำเข้า',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DurianStoresAdd,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/durian-stores/list',
            name: 'รายการทุเรียนในคลัง',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DurianStoresList,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/durian-stores/histories',
            name: 'ประวัติคลังทุเรียน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DurianStoresHistories,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/durian-stores/activities',
            name: 'ประวัติการนำออกทุเรียน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DurianStoresActivities,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/durian-stores/merchants',
            name: 'พ่อค้าแม่ค้าทุเรียน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DurianStoresMerchant,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};


// Durians
const duriansRoutes = {
    path: '/durians',
    name: '2.คัดแยกทุเรียน',
    icon: FeatherIcon.ShoppingCart,
    header: 'Durians',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/durians/add',
            name: 'เพิ่มรายการ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DuriansAdd,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/durians/list',
            name: 'รายการประเภททุเรียน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DuriansList,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/durians/suspend',
            name: 'ระงับใช้งานชั่วคราว',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DuriansSuspend,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/durians/activities',
            name: 'ประวัติการคัดแยกทุเรียน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DuriansActivities,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

//DurianUsed
const durianUsedRoutes = {
    path: '/durian-used',
    name: '3.การใช้ทุเรียน',
    icon: FeatherIcon.ArrowDownCircle,
    header: 'Durian Used',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/durian-used/management',
            name: 'จัดการ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DurianUsedManagement,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/durian-used/histories',
            name: 'ประวัติ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DurianUsedHistories,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};


// Stocks
const stocksRoutes = {
    path: '/stocks',
    name: 'สต๊อก',
    icon: FeatherIcon.Database,
    header: 'Stocks',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/stocks/add',
            name: 'เพิ่มสต๊อก',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: StocksAdd,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/stocks/list',
            name: 'รายการสต๊อก',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: StocksList,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/stocks/suspend',
            name: 'ระงับรายการสต๊อกชั่วคราว',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: StocksSuspend,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/stocks/activities',
            name: 'ประวัติรายการสต๊อก',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: StocksActivities,
            roles: ['Staff', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Budget
const budgetsRoutes = {
    path: '/budget',
    name: 'งบประมาณ',
    icon: FeatherIcon.Database,
    header: 'Budgets',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/budget/add',
            name: 'เพิ่มงบประมาณ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: BudgetsAdd,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/budget/list',
            name: 'รายการงบประมาณ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: BudgetsList,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/budget/type',
            name: 'เพิ่มประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: BudgetTypesAdd,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/budget/type-list',
            name: 'รายการประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: BudgetTypesList,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Expends
const expendsRoutes = {
    path: '/expends',
    name: 'ค่าใช้จ่าย',
    icon: FeatherIcon.Pocket,
    header: 'Expends',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/expends/add',
            name: 'เพิ่มค่าใช้จ่าย',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ExpendsAdd,
            roles: ['Staff', 'Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/expends/list',
            name: 'รายการค่าใช้จ่าย',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ExpendsList,
            roles: ['Staff', 'Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/expends/type',
            name: 'เพิ่มประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ExpendTypesAdd,
            roles: ['Staff', 'Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/expends/type-list',
            name: 'รายการประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ExpendTypesList,
            roles: ['Staff', 'Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Expense
const expensesRoutes = {
    path: '/expense',
    name: 'รายจ่าย',
    icon: FeatherIcon.MinusSquare,
    header: 'Expenses',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/expense/add',
            name: 'รายจ่าย',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ExpensesAdd,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/expense/list',
            name: 'รายการรายจ่าย',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ExpensesList,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/expenses/type',
            name: 'เพิ่มประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ExpenseTypesAdd,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/expense/type-list',
            name: 'รายการประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: ExpenseTypesList,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Income
const incomesRoutes = {
    path: '/income',
    name: 'รายรับ',
    icon: FeatherIcon.PlusSquare,
    header: 'Incomes',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/income/add',
            name: 'เพิ่มรายรับ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: IncomesAdd,
            roles: ['Staff','Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/income/list',
            name: 'รายการรายรับ',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: IncomesList,
            roles: ['Staff','Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/income/type',
            name: 'เพิ่มประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: IncomeTypesAdd,
            roles: ['Staff','Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/income/type-list',
            name: 'รายการประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: IncomeTypesList,
            roles: ['Staff','Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};


// Debts
const debtsRoutes = {
    path: '/debt',
    name: 'หนี้สิน',
    icon: FeatherIcon.ZoomOut,
    header: 'Debts',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/debt/add',
            name: 'เพิ่มหนี้สิน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DebtsAdd,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/debt/list',
            name: 'รายการหนี้สิน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DebtsList,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/debt/type',
            name: 'เพิ่มประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DebtTypesAdd,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/debt/type-list',
            name: 'รายการประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: DebtTypesList,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// MyProperties
const myPropertiesRoutes = {
    path: '/my-property',
    name: 'ทรัพย์สิน',
    icon: FeatherIcon.ZoomIn,
    header: 'MyProperties',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/my-property/add',
            name: 'เพิ่มทรัพย์สิน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: MyPropertiesAdd,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/my-property/list',
            name: 'รายการทรัพย์สิน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: MyPropertiesList,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/my-property/type',
            name: 'เพิ่มประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: MyPropertiesTypesAdd,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/my-property/type-list',
            name: 'รายการประเภท',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: MyPropertiesTypesList,
            roles: ['Finance', 'Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Employees
const employeesRoutes = {
    path: '/employees',
    name: 'พนักงาน',
    icon: FeatherIcon.UserPlus,
    header: 'Employees',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    children: [
        {
            path: '/employees/add',
            name: 'เพิ่มพนักงาน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: EmployeesAdd,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
        {
            path: '/employees/list',
            name: 'รายการพนักงาน',
            icon: BootstrapIcon.BsArrowReturnRight,
            component: EmployeesList,
            roles: ['Admin', 'SuperAdmin', 'RootAdmin'],
            route: PrivateRoute,
        },
    ],
};

// Settings
const settingsRoutes = {
    path: '/settings',
    name: 'ตั้งค่า',
    icon: FeatherIcon.Settings,
    header: 'Settings',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    component: Settings,
    roles: ['Staff', 'Finance', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise', 'Rider'],
    route: PrivateRoute,
};

// Aboutus
const aboutusRoutes = {
    path: '/aboutus',
    name: 'เกี่ยวกับเรา',
    icon: FeatherIcon.Info,
    header: 'Version 1.0',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    component: Aboutus,
    roles: ['Staff', 'Finance', 'Admin', 'SuperAdmin', 'RootAdmin', 'AdminFranchise', 'OwnerFranchise'],
    route: PrivateRoute,
};

// auth
const authRoutes = {
    path: '/account',
    name: 'Auth',
    children: [
        {
            path: '/account/login',
            name: 'Login',
            component: Login,
            route: Route,
        },
        {
            path: '/account/logout',
            name: 'Logout',
            component: Logout,
            route: Route,
        },
        {
            path: '/account/register',
            name: 'Register',
            component: Register,
            route: Route,
        },
        {
            path: '/account/confirm',
            name: 'Confirm',
            component: Confirm,
            route: Route,
        },
        {
            path: '/account/forget-password',
            name: 'Forget Password',
            component: ForgetPassword,
            route: Route,
        },
    ],
};

// flatten the list of all nested routes
const flattenRoutes = (routes) => {
    let flatRoutes = [];

    routes = routes || [];
    routes.forEach((item) => {
        flatRoutes.push(item);

        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

// All routes
const allRoutes = [
    rootRoute,
    dashboardRoutes,
    dashboardStockRoutes,
    adminsRoutes,
    franchisesRoutes,
    ordersRoutes,
    promotionsRoutes,
    adsRoutes,
    customersRoutes,
    voucherRoutes,
    distancesRoutes,
    shippingsRoutes,
    ridersRoutes,
    productsRoutes,
    duriansRoutes,
    durianUsedRoutes,
    durianStoresRoutes,
    stocksRoutes,
    expendsRoutes,
    budgetsRoutes,
    expensesRoutes,
    incomesRoutes,
    debtsRoutes,
    myPropertiesRoutes,
    employeesRoutes,
    settingsRoutes,
    authRoutes,
    aboutusRoutes,
];

const authProtectedRoutes = () => {
    const loggedInUser = getLoggedInUser();
    if (loggedInUser && loggedInUser.role === 'Admin') {
        return [
            dashboardRoutes,
            // dashboardStockRoutes,
            ordersRoutes,
            promotionsRoutes,
            customersRoutes,
            voucherRoutes,
            adsRoutes,
            distancesRoutes,
            shippingsRoutes,
            ridersRoutes,
            productsRoutes,
            durianStoresRoutes,
            duriansRoutes,
            durianUsedRoutes,
            stocksRoutes,
            expendsRoutes,
            //budgetsRoutes,
            //expensesRoutes,
            incomesRoutes,
            //debtsRoutes,
            //myPropertiesRoutes,
            employeesRoutes,
            adminsRoutes,
            franchisesRoutes,
            settingsRoutes,
        ];
    } else if (loggedInUser && loggedInUser.role === 'Finance') {
        return [
            // dashboardRoutes,
            expendsRoutes,
            budgetsRoutes,
            expensesRoutes,
            incomesRoutes,
            debtsRoutes,
            myPropertiesRoutes,
            settingsRoutes,
        ];
    } else if (loggedInUser && (loggedInUser.role === 'SuperAdmin' || loggedInUser.role === 'RootAdmin')) {
        return [
            dashboardRoutes,
            // dashboardStockRoutes,
            ordersRoutes,
            promotionsRoutes,
            customersRoutes,
            voucherRoutes,
            adsRoutes,
            distancesRoutes,
            shippingsRoutes,
            ridersRoutes,
            productsRoutes,
            durianStoresRoutes,
            duriansRoutes,
            durianUsedRoutes,
            stocksRoutes,
            expendsRoutes,
            //budgetsRoutes,
            //expensesRoutes,
            incomesRoutes,
            //debtsRoutes,
            //myPropertiesRoutes,
            employeesRoutes,
            adminsRoutes,
            franchisesRoutes,
            settingsRoutes,
        ];
    } else if (loggedInUser && loggedInUser.role === 'Staff') {
        return [
            //dashboardStockRoutes,
            ordersRoutes,
            customersRoutes,
            voucherRoutes,
            distancesRoutes,
            shippingsRoutes,
            ridersRoutes,
            durianStoresRoutes,
            duriansRoutes,
            durianUsedRoutes,
            stocksRoutes,
            expendsRoutes,
            incomesRoutes,
            settingsRoutes,
        ];
    } else if (loggedInUser && loggedInUser.role === 'AdminFranchise') {
        return [ordersRoutes, customersRoutes, adsRoutes, settingsRoutes,];
    } else if (loggedInUser && loggedInUser.role === 'OwnerFranchise') {
        return [dashboardRoutes, ordersRoutes, customersRoutes, adsRoutes, settingsRoutes,];
    } else if (loggedInUser && loggedInUser.role === 'Rider') {
        return [distancesRoutes, settingsRoutes,];
    } else {
        return [];
    }
};
const allFlattenRoutes = flattenRoutes(allRoutes);
export { allRoutes, authProtectedRoutes, allFlattenRoutes };
